import React from "react";
import { BsStarFill } from "react-icons/bs";



export default function Star(props){
    if (props.type==='short') {
        return(
            <div className="starShort">
                <BsStarFill />
                <span className="num">{props.num}</span>
            </div>
        );
    }else if (props.type==='long') {
        return (
            <div className="starLong">
                { props.grad0 && <div className="dfcsG6"><div className="swr grad0"><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/></div><p className="num">{props.num}</p></div> }
                { props.grad1 && <div className="dfcsG6"><div className="swr grad1"><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/></div><p className="num">{props.num}</p></div> }
                { props.grad2 && <div className="dfcsG6"><div className="swr grad2"><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/></div><p className="num">{props.num}</p></div> }
                { props.grad3 && <div className="dfcsG6"><div className="swr grad3"><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/></div><p className="num">{props.num}</p></div> }
                { props.grad4 && <div className="dfcsG6"><div className="swr grad4"><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/></div><p className="num">{props.num}</p></div> }
                { props.grad5 && <div className="dfcsG6"><div className="swr grad5"><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/></div><p className="num">{props.num}</p></div> }
            </div>
        );
    }else if (props.type==='star1') {
        const review = props.obj?(props.obj.reviewSum?props.obj.reviewSum:0)/ (props.obj.reviewCnt?props.obj.reviewCnt:0):0

        const star = review?(Math.round((review*10))/10) :0
        const starCnt = Math.floor(star)
        
        return (
            <div className="starLong">
                <div className="dfcsG6"><div className={"swr grad"+starCnt}><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/></div><p className="num">{star}</p></div>                
            </div>
        );
    }
};